// 6. BOUTONS D'ACTION
// components/consultation/ActionButtons.tsx
import React from "react";
import { PlusCircle, FileText } from "lucide-react";

interface ActionButtonsProps {
  onAddAnalyse: () => void;
  onAddPrescription: () => void;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  onAddAnalyse,
  onAddPrescription,
}) => {
  return (
    <div className="flex flex-wrap gap-4 mt-10">
      <button
        type="button"
        className="group flex items-center px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98]"
        onClick={onAddAnalyse}
      >
        <PlusCircle
          className="mr-2 transition-transform group-hover:rotate-90"
          size={20}
        />
        Examens supplémentaires
      </button>
      
      <button
        type="button"
        className="group flex items-center px-6 py-3 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-xl hover:from-green-700 hover:to-green-800 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98]"
        onClick={onAddPrescription}
      >
        <FileText
          className="mr-2 transition-transform group-hover:scale-110"
          size={20}
        />
        Ordonnance
      </button>
    </div>
  );
};

export default ActionButtons;